const dic = JSON.parse(localStorage.dic);
import { filterTime } from '@/api/filter';
const POLICY_STATUS = dic['POLICY_STATUS'];
const SUPPLIERS = dic['SUPPLIERS'];
const CURRENCY_TYPE = dic['CURRENCY_TYPE'];
const GUARANTEE_TYPE = dic['GUARANTEE_TYPE'];
const PRODUCT_TYPE2 = dic['PRODUCT_TYPE2'];

export const config = {
  mixins: [],
  data() {
    return {
      columns: []
    };
  },
  methods: {
    // 获取表格列
    getColumns() {
      let columns = [
        {
          title: '签单人',
          align: 'center',
          key: 'agentName',
          minWidth: 120
        },
        {
          title: '保单编号',
          align: 'center',
          key: 'policyNo',
          minWidth: 120,
          fixed: 'left'
        },
        {
          title: '佣金率(%)',
          align: 'center',
          key: 'commission',
          minWidth: 120
        },
        {
          title: '结算汇率',
          align: 'center',
          key: 'settleRate',
          minWidth: 120
        },
        {
          title: '佣金(港币)',
          align: 'center',
          key: 'settleCommissionPrice',
          minWidth: 120
        },
        {
          title: '保单状态',
          align: 'center',
          key: 'policyStatus',
          minWidth: 120,
          render(h, params) {
            let policyStatus = params.row.policyStatus;
            return <span>{POLICY_STATUS[policyStatus]}</span>;
          }
        },
        {
          title: '保单期数',
          align: 'center',
          key: 'commissionIndex',
          minWidth: 120
        },
        {
          title: '供应商',
          align: 'center',
          key: 'suppliers',
          minWidth: 120,
          render(h, params) {
            let suppliers = params.row.suppliers;
            return <span>{SUPPLIERS[suppliers]}</span>;
          }
        },
        {
          title: '保险公司',
          align: 'center',
          key: 'companyName',
          minWidth: 120
        },
        {
          title: '产品名称',
          align: 'center',
          key: 'productName',
          minWidth: 180
        },
        {
          title: '产品类型',
          align: 'center',
          key: 'productType',
          minWidth: 120,
          render(h, params) {
            let productType = params.row.productType;
            return <span>{PRODUCT_TYPE2[productType]}</span>;
          }
        },
        {
          title: '签单日期',
          align: 'center',
          key: 'signDate',
          minWidth: 120,
          render(h, params) {
            let signDate = params.row.signDate;
            return <span>{filterTime(signDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '生效日期',
          align: 'center',
          key: 'effectDate',
          minWidth: 120,
          render(h, params) {
            let effectDate = params.row.effectDate;
            return <span>{filterTime(effectDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '冷静期截止日',
          align: 'center',
          key: 'expirationDate',
          minWidth: 120,
          render(h, params) {
            let expirationDate = params.row.expirationDate;
            return <span>{filterTime(expirationDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '年缴保费',
          align: 'center',
          key: 'paymentPeriod',
          minWidth: 180,
          render(h, params) {
            let paymentPeriod = params.row.paymentPeriod;
            let fee = params.row.fee;
            let currencyType = params.row.currencyType;
            let paymentType = params.row.paymentType;
            let periodUnit = GUARANTEE_TYPE[paymentType] || '年';
            return (
              <span>
                {fee}
                {CURRENCY_TYPE[currencyType]}/{paymentPeriod}{periodUnit}
              </span>
            );
          }
        }
      ];
      this.columns = columns;
    }
  }
};
